<template>
  <router-link 
    :to="to" 
    custom
    v-slot="{ navigate, isActive }">
    <div 
      @click="navigate"
      class="group relative flex items-center gap-3 px-4 py-3 rounded-xl cursor-pointer transition-all duration-300"
      :class="[
        isActive 
          ? 'bg-gradient-to-r from-pink-500/20 to-purple-500/20 text-white' 
          : 'text-gray-300 hover:bg-white/10 hover:text-white',
        `animate-slide-in`
      ]"
      :style="{ animationDelay: `${delay}ms` }">
      
      <!-- آیکون با انیمیشن -->
      <div class="relative">
        <div class="absolute inset-0 bg-gradient-to-r from-pink-500 to-purple-500 rounded-lg blur opacity-0 group-hover:opacity-50 transition-opacity"></div>
        <svg class="relative w-5 h-5 transition-transform group-hover:scale-110 group-hover:rotate-6" :class="[isActive ? 'text-pink-400' : 'text-gray-400 group-hover:text-pink-400']" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="icon" />
        </svg>
      </div>
      
      <!-- متن -->
      <span class="flex-1 text-sm font-medium">{{ label }}</span>
      
      <!-- اندیکاتور فعال -->
      <div v-if="isActive" class="w-1 h-8 bg-gradient-to-b from-pink-500 to-purple-500 rounded-full"></div>
      
      <!-- افکت hover line -->
      <div class="absolute inset-x-0 bottom-0 h-0.5 bg-gradient-to-r from-pink-500 to-purple-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-right"></div>
    </div>
  </router-link>
</template>

<script setup>
defineProps({
  to: { type: String, required: true },
  icon: { type: String, required: true },
  label: { type: String, required: true },
  delay: { type: Number, default: 0 },
  exact: { type: Boolean, default: false }
})
</script>

<style scoped>
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.animate-slide-in {
  animation: slideIn 0.4s ease-out forwards;
  opacity: 0;
}
</style>